export default __webpack_public_path__ + "static/media/Testimonial Model2.42936fa3.svg";